export default function LoaderModals({ className }) {

  return (
    <div className={className} style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
      <div className="lds-heart"><div></div></div>
    </div>
  )
}
